export const ADDRESS_LINKED_TO_CONTRACT = 'ADDRESS_LINKED_TO_CONTRACT'

const HTTP_FORBIDDEN = 403

interface ApiErrorBody {
  error?: { code?: string } | string | null
}

export const isAddressLinkedToContract = (status: number | undefined, responseData: ApiErrorBody | undefined) => {
  const error = responseData?.error

  return status === HTTP_FORBIDDEN && typeof error === 'object' && error?.code === ADDRESS_LINKED_TO_CONTRACT
}
